module.exports = __webpack_public_path__ + "img/66-33.16500dd4.svg";